import { ReactElement } from 'react'
import logo from '../../assets/images/logo.svg'
import SignupStudent from '../../components/Auth/SignupStudent'

function SignUp (): ReactElement {
  return (
    <div className='bg-black min-h-screen font-primary items-center flex justify-center'>
      <h1 className='sr-only'>Sign Up - Create your password</h1>
      <header className='absolute left-[40px] top-[40px]' aria-hidden='true'>
        <img src={logo} className='w-[138px]' alt='logo' />
      </header>

      <section className='flex justify-center'>
        <SignupStudent />
      </section>
    </div>
  )
}

export default SignUp
